import Api from '@/api'

export default {
  namespaced: true,
  state: {
    countries: [],
  },

  mutations: {
    setCountries(state, countries) {
      state.countries = countries
    },

    clearCountries(state) {
      state.countries = null
    },
  },

  actions: {
    async getCountries({ commit }) {
      const { data } = await Api.get(`countries`)
      commit('setCountries', data.data)
    },
  },
}
